import styled from 'styled-components';
import { TimeIcon } from '../../icon/icon';
import { formatNumber } from '../../../utils/util';

// 개별 데이터 타입 정의
interface DriverScheduleDto {
  work: string; // 작업 형태
  target: string; // 도착 시
  amount: number; // 금액
  name: string; // 기업명
}

// 상위 데이터 타입 정의
interface UserMainSectionProps {
  schedules?: DriverScheduleDto[];
  monthlyAmount?: number;
}

export const UserMainSection = ({
  schedules = [],
  monthlyAmount = 0,
}: UserMainSectionProps) => {
  const schedule = schedules[0];
  console.log(schedule);
  return (
    <Wrap workType={schedule?.work}>
      {schedule && schedules.length > 0 ? (
        <div className="today-schedule">
          <p>오늘의 일정</p>
          <span className="working-type">
            {schedule.work === 'full' ? '전일' : '반일'}
          </span>
          <span className="company-name">{schedule.name}</span>
          <div className="time">
            <div className="icon-box">
              <TimeIcon />
            </div>
            <span>{schedule.target}</span>
          </div>
          <span className="price-box">
            <span className="won">₩</span>
            <span className="price">{formatNumber(schedule.amount)}</span>
          </span>
        </div>
      ) : (
        <div className="today-schedule">
          <p>일정이 없습니다.</p>
        </div>
      )}
      <div className="month-pay">
        <p>이번달 매출</p>
        <span className="price-box">
          <span className="title">총금액</span>
          <span className="price">
            <span className="won">₩</span>
            {formatNumber(monthlyAmount)}
          </span>
        </span>
      </div>
    </Wrap>
  );
};

// style
const Wrap = styled.section<{ workType: string }>`
  display: flex;
  gap: 0.8rem;
  > div {
    padding: 1.2rem;
    min-height: 19.2rem;
    flex: 1;
    border-radius: 1.6rem;
    p,
    span {
      color: ${(props) => props.theme.textWhiteColor};
      display: flex;
    }
    p {
      font-size: 1.3rem;
      font-weight: 600;
      line-height: 1.6rem;
    }
    .price-box {
      margin: 1.2rem 0;
      font-size: 1.6rem;
      font-weight: 600;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      gap: 0.2rem;
      .won {
        font-size: 1.2rem;
        color: ${(props) => props.theme.workingTypeColor};
      }
      .price {
        line-height: 2rem;
      }
    }
  }
  .today-schedule {
    background-color: ${(props) => props.theme.homeMainBoxBgColor};
    p {
      margin: 1.3rem 1.2rem;
    }
    .working-type {
      padding: 0.4rem 1.15rem;
      background-color: ${(props) =>
        props.workType === 'full' ? '#00ffba' : '#FFB400'};
      color: ${(props) => props.theme.textBlackColor};
      font-size: 1.1rem;
      font-weight: 600;
      display: inline-flex;
      border-radius: 1.1rem;
      margin: 0.4rem 0.7rem;
      line-height: 1.4rem;
    }
    .company-name {
      font-size: 1.6rem;
      font-weight: 600;
      margin: 0.8rem 0.7rem;
      line-height: 2.1rem;
    }
    .time {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      font-size: 1.3rem;
      margin: 0.8rem 0.7rem;
      .icon-box {
        display: flex;
      }
    }
  }
  .month-pay {
    background-color: ${(props) => props.theme.btnBlueColor};
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      margin: 1.3rem 0;
    }
    .price-box {
      flex-direction: column;
      justify-content: flex-end;
      .price {
        font-size: 1.8rem;
        gap: 0.9rem;
        .won {
          color: ${(props) => props.theme.textWhiteColor};
          opacity: 0.6;
        }
      }
    }
    &::after {
      content: '';
      position: absolute;
      top: 2.5rem;
      right: 1.6rem;
      width: 3.9rem;
      height: 3.5rem;
      background: url('/assets/wallet_line.png') no-repeat;
      background-size: contain;
    }
  }
`;
